module.exports = __webpack_public_path__ + "img/email.d1d49852.png";